/**
 * JSDoc type definitions for Proxy Profile Event Tracking
 */

/**
 * @typedef {'proxy_user_activated'|'proxy_user_switched'|'proxy_user_exited'|
 *          'proxy_access_granted'|'proxy_access_revoked'|'proxy_feature_flag_assigned'|
 *          'proxy_feature_flag_unassigned'} ProxyEventType
 */

/**
 * @typedef {Object} ProxyEventPayload
 * @property {string} user_id - The ID of the user performing the action
 * @property {string} [proxy_user_id] - The ID of the proxy user (for single proxy events)
 * @property {string} [previous_proxy_user_id] - The ID of the previous proxy user (for switch events)
 * @property {string} [new_proxy_user_id] - The ID of the new proxy user (for switch events)
 * @property {string} [feature_flag] - The name of the feature flag (for flag events)
 * @property {string} [action] - The action performed ('ASSIGNED' or 'UNASSIGNED' for flag events)
 * @property {string} timestamp - ISO format timestamp
 * @property {ProxyEventType} event_type - The type of proxy event
 */

/**
 * @typedef {Object} UserEventData
 * @property {string} eventCategory - Category for analytics (e.g., 'proxy_profile')
 * @property {string} eventAction - Action name for analytics
 * @property {string} eventLabel - Human-readable label for the event
 * @property {ProxyEventPayload} eventData - The structured event payload
 */

/**
 * Proxy event tracking service interface
 * @namespace ProxyEventTrackingService
 */

// Export constants for event types
export const PROXY_EVENT_TYPES = {
  ACTIVATION: 'proxy_user_activated',
  SWITCH: 'proxy_user_switched',
  EXIT: 'proxy_user_exited',
  ACCESS_GRANTED: 'proxy_access_granted',
  ACCESS_REVOKED: 'proxy_access_revoked',
  FEATURE_FLAG_ASSIGNED: 'proxy_feature_flag_assigned',
  FEATURE_FLAG_UNASSIGNED: 'proxy_feature_flag_unassigned',
};

export const PROXY_EVENT_CATEGORY = 'proxy_profile';
